import { HttpParams } from '@angular/common/http';

export class CustomHttpParams extends HttpParams {
  constructor(public isBackground: boolean) {
    super();
  }
}
